module.exports = __webpack_public_path__ + "4b33fb8ce0848b940f54ae3f67751054.jpg";